import { makeStyles } from '@material-ui/styles'

export default makeStyles(({ spacing }) => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    gap: spacing(8),
  },
  onlyMyOrdersContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: spacing(8),
    marginRight: spacing(8),
  },
  onlyMyOrdersLabel: {
    fontSize: '14px',
    cursor: 'pointer',
    fontWeight: 500,
  },
}))
